export const SAMPLE_LEAGUE_TABLE = [
  {
    name: 'Borussia Mönchengladbach',
    editing: true,
    id: 'BMG',
  },
  {
    name: 'Borussia Dortmund',
    editing: true,
    id: 'BVB',
  },
  {
    name: 'FC Bayern München',
    editing: true,
    id: 'FCB',
  },
  {
    name: 'VFL Wolfsburg',
    editing: true,
    id: 'VFL',
  },
  {
    name: 'Bayer Leverkusen',
    editing: true,
    id: 'B04',
  },
  {
    name: 'FC Schalke 04',
    editing: true,
    id: 'S04',
  },
  {
    name: 'Hertha BSC Berlin',
    editing: true,
    id: 'BSC',
  },
  {
    name: '1. FC Köln',
    editing: true,
    id: '1FC',
  },
  {
    name: 'FC Ingolstadt',
    editing: true,
    id: 'FCI',
  },
  {
    name: 'Darmstadt 98',
    editing: true,
    id: 'D98',
  },
  {
    name: 'Hamburger SV',
    editing: true,
    id: 'HSV',
  },
  {
    name: 'Eintracht Frankfurt',
    editing: true,
    id: 'SGE',
  },
  {
    name: 'Werder Bremen',
    editing: true,
    id: 'SVW',
  },
  {
    name: 'Hoffenheim',
    editing: true,
    id: 'SAP',
  },
  {
    name: 'FC Augsburg',
    editing: true,
    id: 'FCA',
  },
  {
    name: 'Hannover 96',
    editing: true,
    id: 'H96',
  },
  {
    name: 'Mainz 05',
    editing: true,
    id: 'M05',
  },
  {
    name: 'VFB Stuttgart',
    editing: true,
    id: 'VFB',
  },
];
